export const enum ERouteNames {
  HOME = "/",
  ABOUT = "about",
  DOCTORS = "doctors",
  CLINICS = "clinics",
  EMAIL_CONFIRMATION = "confirmation",
  PASSWORD_RESET = "password-reset",
  PATIENT_ACCOUNT = "patient-account",
  PATIENT_ACCOUNT_APPOINTMENTS = "appointments",
  PATIENT_ACCOUNT_HELP = "help",
  PATIENT_ACCOUNT_PERSONAL_INFO = "personal-information",
  PATIENT_ACCOUNT_ADDITIONAL_DATA = "additional-data",
  PATIENT_ACCOUNT_PASSWORD_N_SECURITY = "password-n-security",
  DOCTOR_ACCOUNT = "doctor-account",
  DOCTOR_ACCOUNT_SCHEDULE_OF_RECEPTIONS = "schedule-of-receptions",
  DOCTOR_ACCOUNT_APPOINTMENTS = "appointments",
  DOCTOR_ACCOUNT_HELP = "help",
  DOCTOR_ACCOUNT_PERSONAL_INFO = "personal-information",
  DOCTOR_ACCOUNT_PROFESSIONAL_DATA = "professional-data",
  DOCTOR_ACCOUNT_PASSWORD_N_SECURITY = "password-n-security",
  DOCTOR_ACCOUNT_HEAD_DOCTOR = "head-doctor",
}
